module.exports = __webpack_public_path__ + "assets/5032db4d6317d304850a7a61add2e955.png";